import AppProvider from 'providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import SettingsPanelProvider from 'providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from 'Routes';
import ChatWidgetProvider from 'providers/ChatWidgetProvider';
import { Provider } from 'react-redux';
import store from 'redux-state/store';
import { Toaster } from 'react-hot-toast';
import AuthInit from 'AuthInit';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <Provider store={store}>
          <SettingsPanelProvider>
            <ChatWidgetProvider>
              <BreakpointsProvider>
                {/* <RouterProvider router={router} /> */}
                <AuthInit />
                <Toaster
                  position="top-right"
                  toastOptions={{
                    success: {
                      duration: 3000,
                      style: {
                        backgroundColor: 'green',
                        color: 'white'
                      }
                    },
                    error: {
                      duration: 3000,
                      style: {
                        backgroundColor: 'red',
                        color: 'white'
                      }
                    }
                  }}
                />
                <ReactQueryDevtools initialIsOpen={false} />
              </BreakpointsProvider>
            </ChatWidgetProvider>
          </SettingsPanelProvider>
        </Provider>
      </AppProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
